<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-control-section>
    <a alt="Edit Filter" (click)="filterDialog.showFilterDialog(currentFilter)" class="btn active filter" title="Advanced Filter">
      <span class="fa-stack">
        <i class="fa fa-filter fa-stack-1x fa-lg"></i>
        <i *ngIf="hasCustomFilter" class="fa fa-check fa-stack-1x custom-filter"></i>
      </span>
    </a>
  </ng-container>

    <ng-container widget-body>

      <div class="widget-toolbar">
        <div class="widget-toolbar-menu">
          <div class="admin-filter" *ngIf="eventFilterText">
            <div class="admin-filter-rule">{{eventFilterText}}</div>
          </div>
        </div>
      </div>

      <div class="table-search">
        <button [class.selected]="isButtonSelected(button)" class="btn btn-default" (click)="handleButtonClick(button)" *ngFor="let button of buttons">
          {{button}}
        </button>

        <ng-content select="[search-toolbar]"></ng-content>
        <input #gb class="form-control" [(ngModel)]="searchString" (input)="diaryEventsFilter()" placeholder="Search..." pInputText type="text">
          <button alt="Export CSV" (click)="export()"class="btn btn-default" pButton type="button" icon="fa-fw fa fa-download">Export</button>
      </div>

      <div *ngIf="selectedFilterButton == 'Dated'" class="widget-content grid">
        <div class="col full-height calendar">
          <mojo-calendar [diaryEvents]="diaryEvents$ | async" [date]="date" (onDateChanged)="dateChanged($event)" [(view)]="view"></mojo-calendar>
        </div>
        <div class="col full-height events">
          <p-progressSpinner *ngIf="(diaryEventsLoading$ | async)"></p-progressSpinner>
          <mojo-diary-events *ngIf="!(diaryEventsLoading$ | async)" [diaryEvents]="diaryEventsForEventCards$ | async"></mojo-diary-events>
        </div>
      </div>
      <div *ngIf="selectedFilterButton == 'Undated'" class="widget-content grid">
        <div class="col full-height events">
          <p-progressSpinner *ngIf="(diaryEventsLoading$ | async)"></p-progressSpinner>
          <mojo-diary-events *ngIf="!(diaryEventsLoading$ | async)" [diaryEvents]="diaryEventsForEventCards$ | async" [isUndated]="true"></mojo-diary-events>
        </div>
      </div>
    </ng-container>
</mojo-widget>

<mojo-filter-editor-dialog #filterDialog (onSaveFilter)="filterEdited($event)"
  [queryBuilderConfigProvider]="configProvider" [sysAdminFilterText]="sysAdminFilterText$ | async">
  <div custom-content>
    <label class="col-8 sentence">
      Display entries for Notice by Date
    </label>
    <div class="col-4 pr-0" style="display:inline-block;">
      <p-dropdown appendTo="body" [options]="noticeOptions | async" [(ngModel)]="includeNotices" optionLabel="label"
        optionValue="value" />
    </div>

  </div>
</mojo-filter-editor-dialog>

